import ErrorBoundaryPageView from './ErrorBoundaryPage.view';
export * from './ErrorBoundaryPage.view';

export const ErrorBoundaryPage = (props) => ErrorBoundaryPageView(props);

export default ErrorBoundaryPage;

